import { Link } from 'react-router-dom';

export default function WhyStudents() {
  const reasons = [
    {
      icon: 'ri-shield-check-line',
      title: '学生専用の審査基準',
      description: '学生向けカードは収入がなくても申込み可能。親権者の同意があれば18歳から作れます。'
    },
    {
      icon: 'ri-money-yen-circle-line',
      title: '年会費無料が基本',
      description: '学生向けカードのほとんどが年会費永年無料。維持費を気にせず持ち続けられます。'
    },
    {
      icon: 'ri-gift-line',
      title: '学生限定特典が豊富',
      description: '書籍購入割引、旅行保険、ポイント優遇など、学生生活をサポートする特典が充実。'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'クレヒスを早期構築',
      description: '学生のうちからカードを使うことで、将来の住宅ローンや車のローン審査に有利なクレジットヒストリーを構築できます。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            学生でも作れる理由
          </h2>
          <p className="text-lg text-gray-600">
            学生向けクレジットカードは、収入がなくても申込みできる特別な審査基準が設けられています
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-orange-50 border border-orange-100 rounded-2xl p-8">
          <div className="flex items-start space-x-4">
            <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-orange-600 text-xl"></i>
            </div>
            <div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">
                申込み時の注意点
              </h4>
              <p className="text-gray-700 leading-relaxed">
                18歳・19歳の方は親権者の同意が必要です。また、学生証や在学証明書の提出を求められる場合があります。申込み前に必要書類を確認しておきましょう。
              </p>
            </div>
          </div>
        </div>

        {/* 3️⃣ 記事途中にCTAカード配置 */}
        <div className="mt-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-8 shadow-2xl">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
                <i className="ri-fire-line text-amber-300"></i>
                <span className="text-white text-sm font-bold">人気No.1</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                三井住友カード（NL）
              </h3>
              <p className="text-white/90 text-sm mb-4">
                学生ポイント最大10%還元 + 対象店舗で最大7%還元
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full whitespace-nowrap">
                  年会費永年無料
                </span>
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full whitespace-nowrap">
                  最短10秒発行
                </span>
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full whitespace-nowrap">
                  学生限定特典
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              <Link
                to="/mitsui"
                className="inline-flex items-center justify-center gap-2 bg-white text-teal-600 font-bold px-8 py-4 rounded-xl hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-list-3-line"></i>
                詳細ページを見る
              </Link>
              <a
                href="https://www.smbc-card.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-teal-700 text-white font-bold px-8 py-4 rounded-xl hover:bg-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                公式サイトはこちら
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
